import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the TimeFormatPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'timeFormat',
})
export class TimeFormatPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: any, fmt: string, ...args) {
    if (typeof value === 'number') {
      //如果是 秒 为单位就变为毫秒
      if(String(value).length == 10 || String(value).length==11) value*=1000;

      let date = new Date(value);
      var o = {
        'Y+': date.getUTCFullYear(), //年份
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
        W: date.getDay(),
      };
      var weekMap = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ];
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        );
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt) && k != 'W') {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          );
        }
        if (new RegExp('(' + k + ')').test(fmt) && k == 'W') {
          fmt = fmt.replace(RegExp.$1, weekMap[o[k]]);
        }
      }
      return fmt;
    } else return '';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/time-format/time-format.ts